import React from 'react';
import './LineSpacer.css';

const LineSpacer = ({ height = "20px", lineWidth = "100%" }) => {

  return (
    <div className='line-spacer' style={{ height: height }}>
      <div className='dashed-line' style={{ width: lineWidth }} />
    </div>
  );
};

export default LineSpacer;
